












































































































































































































































































































































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
/* import all the components needed in the page */
import { SwForm, SwFormRow, SwFormColumn } from '@libs-uuif/shared/sw-form';
import { SwModal, SwModalBody } from '@libs-uuif/shared/sw-modal';
import { SwSteps } from '@libs-uuif/shared/sw-steps';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { SwTitlePane } from '@sonicwall/unified-ui-framework/src/shared/sw-title-pane';
import { SwStatusInfo } from '@sonicwall/unified-ui-framework/src/shared/sw-status-info';
import CustomCatalogMapping from './custom-catalog-mapping.vue';
import UserOperatorsMapping from './user-operators-mapping.vue';

const cssPrefix = 'sw-ftr-form';
const cssPrefix2 = 'operator_wrapper';
const storeName = 'ConnectWiseManageStoreModule';
// const profileStoreName = 'SnbProfileStoreModule';
const COMPLETE = 'complete';
const ACTIVE = 'active';
const DEFAULT = 'default';
const FINISH = 'Submit';
const NEXT = 'Next';
// Below is the RegEx to validate Server Host Name
// eslint-disable-next-line no-useless-escape
const hostNameRegex = new RegExp('(?=^.{4,253}$)(^((?!-)[a-zA-Z0-9-]{0,62}[a-zA-Z0-9]\.)+[a-zA-Z]{2,63}$)');

@Component({
  components: {
    SwButton,
    SwForm,
    SwFormRow,
    SwFormColumn,
    SwModal,
    SwModalBody,
    SwSteps,
    SwTextfield,
    SwSelect,
    SwCheckbox,
    SwIcon,
    SwTitlePane,
    SwStatusInfo,
    CustomCatalogMapping,
    UserOperatorsMapping,
  },
  directives: {
    tooltip,
  },
})
export default class ConfigurationWizard extends SwExtendedVue {
  // below prop is used to show/hide the modal
  @Prop({ default: false }) display: boolean;

  cssPrefix = cssPrefix;
  cssPrefix2 = cssPrefix2;
  // data models for ticketing page
  serviceBoard: string = '';
  cwCritical: string = '';
  cwHigh: string = '';
  activeIndex: number = 0;
  btnName: string = 'Next';
  modalTemp: boolean = false;
  statusMessage: string = '';
  showMessage: boolean = false;
  messageColor: boolean = false;

  // below is the data for steps in wizard
  get steps() {
    if (this.showCustomCatalogMapping) {
      return [
        {
          label: '1',
          title: this.$t('psaIntegration.connect')
          .toString(),
          state: 'active',
        },
        {
          label: '2',
          title: this.$t('psaIntegration.additions')
          .toString(),
          state: 'default',
        },
        {
          label: '3',
          title: this.$t('psaIntegration.ticketing')
          .toString(),
          state: 'default',
        },
        {
          label: '4',
          title: this.$t('psaIntegration.operators')
          .toString(),
          state: 'default',
        },
        {
          label: '5',
          title: this.$t('psaIntegration.review')
          .toString(),
          state: 'default',
        },
      ];
    }
    return [
      {
        label: '1',
        title: this.$t('psaIntegration.connect')
        .toString(),
        state: 'active',
      },
      {
        label: '2',
        title: this.$t('psaIntegration.ticketing')
        .toString(),
        state: 'default',
      },
      {
        label: '3',
        title: this.$t('psaIntegration.operators')
        .toString(),
        state: 'default',
      },
      {
        label: '4',
        title: this.$t('psaIntegration.review')
        .toString(),
        state: 'default',
      },
    ];
  }

  get wizardBodyTitle() {
    if (this.showCustomCatalogMapping) {
      return [
        this.$t('psaIntegration.connetionDetails')
        .toString(),
        this.$t('psaIntegration.connectwiseManage.catalogMapping')
        .toString(),
        this.$t('psaIntegration.connectwiseManage.ticketingConfiguration')
        .toString(),
        '',
        this.$t('psaIntegration.confirmSettings')
        .toString(),
      ];
    }
    return [
      this.$t('psaIntegration.connetionDetails')
      .toString(),
      this.$t('psaIntegration.connectwiseManage.ticketingConfiguration')
      .toString(),
      '',
      this.$t('psaIntegration.confirmSettings')
      .toString(),
    ];
  }

  get count() {
    return this.steps.length;
  }

  get serverDetailsFromStore():any {
    return { ...this.$store.getters[`${storeName}/getCwServerDetails`] };
  }

  get ticketConfigFromStore() {
    return this.$store.getters[`${storeName}/getTicketConfigurations`];
  }

  get tempServerDetails() {
    return this.$store.getters[`${storeName}/getCwServerDetailsTemp`];
  }

  get tempTicketConfig() {
    return this.$store.getters[`${storeName}/getTempTicketConfigurations`];
  }

  get serviceTicketList() {
    return this.$store.getters[`${storeName}/getServiceBoard`];
  }

  get cwPriorityOptions() {
    return this.$store.getters[`${storeName}/getPriorityOptions`];
  }

  get displayModal() {
    this.modalTemp = this.display;
    return this.modalTemp;
  }

  get previousDisabled() {
    return this.activeIndex !== 0;
  }

  get employeeList() {
    return this.$store.getters[`${storeName}/getEmployees`];
  }

  get customCatalogStepValid() {
    return this.$store.getters[`${storeName}/getIsCustomCatalogStepValidated`];
  }

  get showCustomCatalogMapping() {
    return this.$store.getters[`${storeName}/getShowCustomCatalogMapping`];
  }

  get cwProductBindings() {
    return this.$store.getters[`${storeName}/getCwProductBinding`];
  }

  get isStep1Validated() {
    if (
      this.serverDetailsFromStore.serverUrl !== ''
      && this.serverDetailsFromStore.companyId !== ''
      && this.serverDetailsFromStore.apiPrivateKey !== ''
      && this.serverDetailsFromStore.apiPublicKey !== ''
    ) {
      const ticketValidationCond:boolean = (this.ticketConfigFromStore.serviceBoard === ''
        || this.ticketConfigFromStore.ccCritical === ''
        || this.ticketConfigFromStore.ccHigh === '');
      if (
        ((!this.showCustomCatalogMapping && this.activeIndex === 1) || (this.showCustomCatalogMapping && this.activeIndex === 2))
        && ticketValidationCond
      ) {
        return true;
      }
      if (this.showCustomCatalogMapping && this.customCatalogStepValid && this.activeIndex === 1) {
        return true;
      }
      return false;
    }
    return true;
  }

  set displayModal(newValue) {
    this.modalTemp = newValue;
  }

  async fetchServiceBoardList() {
    this.$store
    .dispatch(`${storeName}/getServiceBoard`)
    .then((result) => {
      this.$store.commit(`${storeName}/updateServiceBoard`, result);
      this.$store.commit('stopLoading');
    })
    .catch((error) => {
      this.$store.commit('stopLoading');
      console.error(error);
      if (error.response) {
        this.renderErrorMessage(error.response.data.message);
      } else {
        this.renderErrorMessage(this.$t('psaIntegration.connectwiseManage.genErrMsg1')
        .toString());
      }
    });
  }

  async fetchPriorityOptions() {
    this.$store
    .dispatch(`${storeName}/getPriorityOptions`)
    .then((result) => {
      this.$store.commit(`${storeName}/updatePriorityOptions`, result);
      this.$store.commit('stopLoading');
    })
    .catch((error:any) => {
      this.$store.commit('stopLoading');
      console.error(error);
      if (error.response) {
        this.renderErrorMessage(error.response.data.message);
      } else {
        this.renderErrorMessage(this.$t('psaIntegration.connectwiseManage.genErrMsg1')
        .toString());
      }
    });
  }

  async fetchTicketConfig() {
    this.$store
    .dispatch(`${storeName}/getTicketConfig`)
    .then((result) => {
      this.$store.commit(`${storeName}/saveTicketConfiguration`, result);
      this.$store.commit('stopLoading');
    })
    .catch((error) => {
      this.$store.commit('stopLoading');
      if (error.response) {
        if (error.response.status !== 404) {
          this.renderErrorMessage(error.response.data.message);
          console.error(error);
        }
      } else {
        this.renderErrorMessage(this.$t('psaIntegration.connectwiseManage.genErrMsg1')
        .toString());
      }
    });
  }

  validateServerUrl() {
    if (!this.serverDetailsFromStore.serverUrl.match(hostNameRegex) && this.serverDetailsFromStore.serverUrl !== '') {
      this.renderErrorMessage(
        'Invalid Server Host Name.',
      );
      return 0;
    }
    if (
      this.statusMessage
        === 'Invalid Server Host Name.'
    ) {
      this.hideErrorMessage();
    }
    return 1;
  }

  async testConnOrvalidateServerDetails(mode:string) {
    this.$store
    .dispatch(`${storeName}/checkIntegrationConfig`)
    .then(async (response:any) => {
      if (mode === 'test') {
        if (response?.operationStatus === 'NOK') {
          this.renderErrorMessage(response?.msgDesc, true);
        } else {
          this.$store.commit('displayMessage', { infoType: 'success', infoMsg: response?.msgDesc });
        }
      }
    })
    .catch((error:any) => {
      if (error.response) {
        this.renderErrorMessage(error?.response?.data?.msgDesc);
      } else {
        this.renderErrorMessage(this.$t('psaIntegration.connectwiseManage.genErrMsg1')
        .toString());
      }
      console.error(error);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }

  storeConfigurations() {
    this.$store
    .dispatch(`${storeName}/saveCwIntegrationDetails`)
    .then(() => {
      this.$store.commit('stopLoading');
      this.$store.commit(`${storeName}/updateSubmitted`, true);
      this.$emit('modalClosed');
      this.showWizardInitialState();
    })
    .catch((error) => {
      this.$store.commit('stopLoading');
      if (error.response) {
        if (error.response.status === 500) {
          this.$store.commit(`${storeName}/updateSubmitted`, true);
          this.$emit('modalClosed');
          this.$store.commit(`${storeName}/updateWarning`, true);
          this.$store.commit(`${storeName}/updateWarningMessage`, error.response.data.message);
          this.showWizardInitialState();
        } else {
          this.renderErrorMessage(error.response.data.message);
        }
      } else {
        this.renderErrorMessage(this.$t('psaIntegration.connectwiseManage.genErrMsg1')
        .toString());
      }
      console.error(error);
    });
  }

  getLabelById(arr: any, value: any) {
    if (arr && value) {
      const element = arr.filter((obj: any) => obj.id === value)[0];
      if (element) {
        return element.label;
      }
      return '';
    }
  }

  isConfigurationUpdated() {
    if (
      JSON.stringify(this.tempServerDetails)
        !== JSON.stringify(this.serverDetailsFromStore)
      || JSON.stringify(this.tempTicketConfig)
        !== JSON.stringify(this.ticketConfigFromStore)
    ) {
      return true;
    }
    return false;
  }

  closeModal() {
    this.$emit('modalClosed');
    this.hideErrorMessage();
  }

  updateServerDetails(key: any, event: any) {
    this.$store.commit(`${storeName}/updateCwServerDetails`, { key, value: event });
  }

  updateTicketConfig(key: string, event: string) {
    this.$store.commit(`${storeName}/updateTicketConfiguration`, { key, value: event });
  }

  updateEmployeeList(emp: any) {
    this.$store.commit(`${storeName}/updateEmployees`, emp);
  }

  renderErrorMessage(message: string, color: boolean = false) {
    this.messageColor = color;
    this.showMessage = true;
    this.statusMessage = message;
  }

  hideErrorMessage() {
    this.showMessage = false;
  }

  // below methods are used to navigate between steps in wizard
  incrementStepCount() {
    this.steps[this.activeIndex].state = COMPLETE;
    this.activeIndex += 1;
    this.steps[this.activeIndex].state = ACTIVE;
    if (this.activeIndex === this.count - 1) {
      this.btnName = FINISH;
    }
  }

  async onNext() {
    if (this.btnName === FINISH) {
      if (this.isConfigurationUpdated() || !this.isConfigurationUpdated()) {
        this.storeConfigurations();
      } else {
        this.$emit('modalClosed');
        this.showWizardInitialState();
      }
    } else if (this.activeIndex < this.count - 1) {
      this.hideErrorMessage();
      if (this.activeIndex === 0) {
        if (this.validateServerUrl()) {
          await this.testConnOrvalidateServerDetails('validate');
          if (!this.showCustomCatalogMapping) {
            this.updateTicketConfig('id', (this.$store.getters.getUserId || ''));
            await this.fetchServiceBoardList();
            await this.fetchPriorityOptions();
            await this.fetchTicketConfig();
          }
          this.incrementStepCount();
        }
      } else if (this.activeIndex === 1) {
        this.updateTicketConfig('id', (this.$store.getters.getUserId || ''));
        if (this.showCustomCatalogMapping) {
          await this.onSubmitCustomCatalogMapping();
          await this.fetchServiceBoardList();
          await this.fetchPriorityOptions();
          await this.fetchTicketConfig();
        }
        this.incrementStepCount();
      } else if (this.activeIndex === 2) {
        this.incrementStepCount();
      } else if (this.showCustomCatalogMapping && this.activeIndex === 3) {
        this.incrementStepCount();
      }
    }
  }

  onPrev() {
    this.hideErrorMessage();
    if (this.activeIndex > 0 && this.activeIndex < this.count) {
      this.steps[this.activeIndex].state = DEFAULT;
      this.activeIndex -= 1;
      this.steps[this.activeIndex].state = ACTIVE;
      this.btnName = NEXT;
    }
  }
  showWizardInitialState() {
    this.btnName = NEXT;
    // this.steps[3].state = DEFAULT;
    this.steps[2].state = DEFAULT;
    this.steps[1].state = DEFAULT;
    this.steps[0].state = ACTIVE;
    this.activeIndex = 0;
  }

  async onSubmitCustomCatalogMapping() {
    console.warn('inside custom catalog api put');
    let mappings: any = [];
    if (this.cwProductBindings.length !== 0) {
      mappings = this.cwProductBindings.map((prods:any) => {
        return {
          cw_catalog_id: prods.cwCatalogId,
          msw_catalog_id: prods.mswCatalogId,
        };
      });
    }
    this.$store
    .dispatch(`${storeName}/addProductCatalogs`, mappings)
    .then((resp:any) => {
      console.warn(resp);
    })
    .catch((error:any) => {
      console.error(error);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }
}
